import { jwtDecode } from 'jwt-decode';

/**
 * Декодирование payload JWT без проверки подписи — только чтение claim'ов (подпись проверяет
 * бэкенд). Обёртка над `jwt-decode`: возвращает claim'ы либо null (пустой/некорректный токен),
 * чтобы вызывающим не ловить исключение.
 */
export function decodeJwt<T = Record<string, unknown>>(
  token: string | null | undefined
): T | null {
  if (!token) return null;
  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
}

/**
 * Истёк ли access-токен или истечёт в ближайшие `marginSeconds` — без запроса к серверу.
 * Токен, срок которого прочитать нельзя, считается действующим: решает бэкенд.
 */
export function isJwtExpiring(
  token: string | null | undefined,
  marginSeconds: number,
  now: number = Date.now()
): boolean {
  const exp = decodeJwt<{ exp?: unknown }>(token)?.exp;
  if (typeof exp !== 'number') return false;
  return (exp - marginSeconds) * 1000 <= now;
}
